import { Component } from '@angular/core';

@Component({
  selector: 'dl-page-header-title',
  templateUrl: './page-header-title.component.html',
  styleUrls: ['./page-header-title.component.css'],
})
export class DlPageHeaderTitleComponent {}
